export const removeCircleIcon = {
    data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><g stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.4"><path d="m15.182 8.818-6.364 6.363m0-6.363 6.364 6.363" class="a"/><circle cx="12" cy="12" r="11.25"/></g></svg>`,
    name: 'remove-circle'
};